import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        headerTitle: {
            color: theme.palette.secondary[900],
            fontWeight: theme.typography.h1.fontWeight,
            fontSize: theme.typography.h1.fontSize,
            display: 'flex',
            alignItems: 'center',
            fontFamily: theme.typography.fontFamily,
        },
        disabledButton: {
            color: `${theme.palette.secondary[400]} !important`,
        },
        accordion: {
            margin: `${theme.spacing(0.5)} 0 !important`,
        },
        accordionSummary: {
            margin: '0 !important',
            '& .MuiAccordionSummary-content.Mui-expanded':
            {
                margin: '0 !important',
            },
        },
        resizeWrapper: {
            resize: 'vertical',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
        },
    }
})
